import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { FaSignInAlt, FaSearch } from 'react-icons/fa';
import Search from '../../Components/Search/Search';
import useAuth from '../../hooks/useAuth';
import Avatar from '../Avatar/Avatar';

const Navbar = () => {
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();
  const { userData, refreshUserData } = useAuth(false); // Use refreshUserData to manually reload user data

  const handleUserIconClick = () => {
    if (userData) {
      navigate('/Dashboard');
    } else {
      navigate('/account');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('auth-token');
    localStorage.removeItem('username');
    localStorage.removeItem('profileImage');
    navigate('/');
    window.dispatchEvent(new Event('storage'));
  };

  const closeSearch = () => {
    setShowSearch(false);
  };

  useEffect(() => {
    // Listen for custom productBoxClosed event and refresh user data
    const handleProductBoxClose = () => {
      refreshUserData(); // Reload user data on close event
    };

    // Listen for auth-change event (when user is logged out from another device)
    const handleAuthChange = () => {
      refreshUserData(); // Reload user data when auth state changes
    };

    window.addEventListener('productBoxClosed', handleProductBoxClose);
    window.addEventListener('storage', handleProductBoxClose);
    window.addEventListener('auth-change', handleAuthChange);

    return () => {
      window.removeEventListener('productBoxClosed', handleProductBoxClose);
      window.removeEventListener('storage', handleProductBoxClose);
      window.removeEventListener('auth-change', handleAuthChange);
    };
  }, [refreshUserData]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <div className="navbar-logo">
             <Link to="/">
              <img src="https://dzsyhtfpcz9op.cloudfront.net/staticResources/logo_intoreality.tv.png" alt="Into Reality Logo" />
              </Link>
          </div>
        </div>

        <div className="navbar-right">
		{/*<div className="search-icon" onClick={() => setShowSearch(!showSearch)}>
            <FaSearch size={30} color="white" style={{ cursor: 'pointer' }} />
          </div>

		{showSearch && <Search closeSearch={closeSearch} />*/}

          {userData ? (
            <div className="navbar-user">
              <Avatar
                user={userData}
                size={44}
                onClick={handleUserIconClick}
                style={{ border: '2px solid #fff' }}
              />
              <button
                className="logout-button"
                onClick={handleLogout}
                style={{ display: 'none' }}
              >
                Logout
              </button>
            </div>
          ) : (
            <FaSignInAlt
              size={40}
              color="white"
              onClick={handleUserIconClick}
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
